<template>
  <div class="online-survey">
    <div>
      <div class="bannerbox">
        <!-- <el-image fit="cover" :src="require('@/assets/imgs/banner.png')">
                </el-image> -->
        <div class="banner">
          <img
            style="width: 100%; height: auto"
            src="@/assets/imgs/service.jpg"
            alt=""
          />
        </div>
      </div>
      <div class="newsbox">
        <div
          class="clearfix wrap"
          style="padding-top: 60px; padding-bottom: 60px"
        >
          <div class="menutitle">
            <el-breadcrumb separator-class="el-icon-arrow-right">

              <el-breadcrumb-item :to="{ path: '/spectatorService' }"
                >观众服务</el-breadcrumb-item
              >
              <el-breadcrumb-item
                :to="{ path: '/spectatorService/onlineSurvey' }"
                >在线调查</el-breadcrumb-item
              >
            </el-breadcrumb>
          </div>
          <div class="newscontent" @scroll="handleScroll($event)">
            <ul class="newslist">
              <li v-for="inf in informationData" :key="inf.data">
                <div class="newstit">
                  <h3>
                    {{ inf.title }}
                    <!-- <a href="javascript:void(0)">{{ inf.title }}</a> -->
                  </h3>
                  <span style="display:block"
                    >发布日期：{{ inf.publishTime }}
                    <span v-if="inf.viewCount">
                      浏览次数: {{ inf.viewCount }}次</span
                    ></span
                  >
                  <p v-html="inf.description"></p>
                  <button class="more" @click="go(inf)">了解详情</button>
                </div>
              </li>
            </ul>
            <div class="load" v-if="nextFlag">
              <a-spin v-if="tipMessage != '数据已加载完!'" /><span
                class="load-text"
                >{{ tipMessage }}</span
              >
            </div>
            <div v-if="finalFlag" class="load">
              <span class="load-text">{{ tipMessage }}</span>
            </div>
          </div>
          <div class="service">
            <h3 class="title">观众服务</h3>
            <hr />
            <el-menu :default-openeds="defaultOpeneds">
              <SideBar :list="sideBarData"></SideBar>
            </el-menu>
            <h3 class="title">服务指南</h3>
            <hr />
            <h4 class="til">开馆时间</h4>
            <h5 class="tips" v-if="List[0]" v-html="List[0].value">
              <!-- 友情提示：上饶美术馆周一闭馆（不含节
                          假日）疫情期间实行分时预约参观。
                          每日可预约时间段如下：9:00-11:00； 11:00-14:00；14:00-16:00<br />
                          地址：上饶市信州区平江道60号<br />
                          电话：022—83883300 -->
            </h5>
            <h4 class="til">美术馆地址</h4>
            <div class="map">
              <baidu-map
                style="height: 103px"
                @ready="mapHandle"
                :scroll-wheel-zoom="true"
                :key="map.longitude"
              ></baidu-map>
            </div>
            <button @click="gotoMenu()" class="order">参展预约</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SideBar from "../../components/sideBar";
export default {
  components: {
    SideBar,
  },
  data() {
    return {
      page: {
        pageNum: 1,
        pageSize: 5,
      },
      defaultOpeneds: ["menu2"],
      map: {
        longitude: 1,
        latitude: 1,
        address: "",
      },

      nextFlag: true,
      finalFlag: false,
      tipMessage: "努力加载中...",
      sideBarData: [
        {
          name: "参观预约",
          index: "menu1",
          path: `/spectatorService/appointment`,
          children: [],
        },
        {
          name: "服务指南",
          index: "menu2",
          // path: `/spectatorService/guide`,
          children: [
            {
              name: "· 参观须知",
              index: "dataset1",
              path: `/spectatorService/konw`,
              children: [],
            },
            {
              name: "· 开馆时间",
              index: "dataset2",
              path: `/spectatorService/opentime`,
              children: [],
            },
            {
              name: "· 交通指南",
              index: "dataset3",
              path: `/spectatorService/traffic`,
              children: [],
            },
          ],
        },
        {
          name: "电子留言",
          index: "menu3",
          path: `/spectatorService/electronicMessage`,
          children: [],
        },
        {
          name: "在线调查",
          index: "menu4",
          path: `/spectatorService/onlineSurvey`,
          children: [],
        },
      ],
      list: [],
      List: [],
      informationData: [],
      current: 0,
    };
  },
  mounted() {
    console.log(111111);
    // var that = this;
    // console.log("this", this);
    // this.$axios.get("/frontapi/academic/active/list").then(
    //   function (res) {
    //     console.log(res);
    //     that.informationData = res.data.rows;
    //   },
    //   function () {
    //     console.log("请求失败");
    //   }
    // );
    var that = this;
    this.getList();
    this.$axios
      .get(
        "/frontapi/service/information/list?pageNum=1&pageSize=10&name=开馆时间"
      )
      .then(
        function(res) {
          console.log(res);
          that.List = res.data.rows;
          console.log(that.List, "111");
        },
        function() {
          console.log("请求失败");
        }
      );
    this.$axios({
      method: "get",
      url: "/frontapi/service/information/mapCoordinate",
      data: {},
    }).then((res) => {
      if (res.data.mapCoordinate) {
        var arr = res.data.mapCoordinate.split(",");
        this.map.longitude = parseFloat(arr[0]);
        this.map.latitude = parseFloat(arr[1]);
        this.map.address = res.data.address;
      }
    });
  },
  methods: {
    gotoMenu() {
      //指定跳转的地址 this.$router.replace('/menu')
      this.$router.push("/spectatorService/appointment").catch((err) => {});
    },
    mapHandle({ BMap, map }) {
      var point = new BMap.Point(this.map.longitude, this.map.latitude);
      map.centerAndZoom(point, 13);
      var icon = new BMap.Icon(
        require("../../assets/imgs/map-position.png"),
        new BMap.Size(74, 84)
      );
      var marker = new BMap.Marker(point, { icon: icon }); // 创建标注
      map.addOverlay(marker); // 将标注添加到地图中
      var html = [];
      var opts = {
        width: 250,
        height: 30,
      };

      html.push('<div class="mapTipWindow"> <ul>');
      html.push("<li>" + this.map.address + "</li>");
      html.push("</ul></div>");
      var infowindow = new BMap.InfoWindow(html.join(""), opts);
      marker.addEventListener("click", function() {
        this.openInfoWindow(infowindow);
      });
    },
    go(val) {
      this.$router.push({
        path: "/spectatorService/surveyDetails",
        query: { id: val.id },
      });
    },
    handleScroll(event) {
      console.log(123232323);
      let Scroll = event.target;
      //滚动条到底部的条件
      if (
        Scroll.scrollHeight - (Scroll.scrollTop + Scroll.clientHeight) > 10 &&
        !this.nextFlag &&
        !this.finalFlag
      ) {
        this.nextFlag = true;
        this.page.pageNum++;
        setTimeout(() => {
          this.getList();
        }, 1000);
      }
    },
    getList() {
      var that = this;
      this.$axios
        .get("/frontapi/survey/questionnaire/list", {
          params: {
            pageNum: this.page.pageNum,
            pageSize: this.page.pageSize,
          },
        })
        .then(
          function(res) {
            console.log(res);
            that.informationData = [...that.informationData, ...res.data.rows];
            if (res.data.rows.length == 0) {
              that.tipMessage = "数据已加载完!";
              that.finalFlag = true;
            }
            that.nextFlag = false;
          },
          function() {
            // console.log("请求失败");
          }
        );
    },
  },
};
</script>
<style scoped>
::v-deep .mapTipWindow li {
  font-size: 18px;
}
img {
  font-size: 18px;
}
* {
  margin: 0;
  padding: 0;
}
.online-survey {
  padding-top: 1.111111rem /* 80px -> 1.111111rem */;
  height: 100%;
  width: 100%;
}
.online-survey .wrap {
  margin: 0 auto;
  width: 1200px;
  background: #f4f4f4;
}
.online-survey .banner {
  height: auto;
  width: 100%;
}
.online-survey .newsbox {
  background: #f4f4f4;
}
.clearfix:after {
  display: block;
  content: "";
  overflow: hidden;
  clear: both;
  height: 0;
}
.online-survey >>> .menutitle {
  cursor: pointer;
}
.online-survey >>> .is-link {
  font-weight: 400;
  color: #606266;
  cursor: pointer;
}
.online-survey
  .menutitle
  >>> .el-breadcrumb__item:last-child
  .el-breadcrumb__inner {
  font-weight: 700;
  color: #303133;
  cursor: pointer;
}
.online-survey .newscontent {
  padding: 0 30px;
  width: 860px;
  height: 1120px;
  background: #ffffff;
  float: left;
  margin-top: 40px;
  border-radius: 10px;
  overflow: scroll;
}
.online-survey .newscontent::-webkit-scrollbar {
  display: none;
}
.online-survey .newslist {
  width: 100%;
}
.online-survey .newslist li {
  width: 100%;
  padding-top: 30px;
  /* padding: 30px 30px 20px; */
}
.online-survey .newslist {
  width: 100%;
}

.online-survey .newslist img {
  float: left;
  width: 200px;
  height: 260px;
}

.online-survey .newstit {
  width: 100%;
  height: 246px;
  border-bottom: 1px solid #eeeeee;
}
.online-survey .newstit h3 {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  height: 25px;
  font-size: 24px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #222222;
  line-height: 25px;
}
/* .newstit h3 a {

  color: #222222;
  cursor: default;
} */
.online-survey .newstit span {
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #666666;
  line-height: 54px;
}
.online-survey .newstit > p {
  /* overflow: hidden;
  text-overflow: ellipsis;
  word-break:break-all; */
  height: 104px;
  font-size: 14px;
  font-family: Source Han Sans CN-;
  font-weight: 500;
  color: #222222;
  line-height: 24px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5;
}
.online-survey .newstit .more {
  float: right;
  width: 150px;
  height: 30px;
  border: 1px solid #b78c0d;
  border-radius: 3px 3px 3px 3px;
  background: #fff;
  color: #b78c0d;
  margin-top: 12px;
  font-size: 14px;
  cursor: pointer;
}
.online-survey .load {
  display: flex;
  width: 100%;
  height: 40px;
  align-items: center;
  justify-content: center;
  transition: all 2s;
}
::v-deep .ant-spin-dot-item {
  background-color: #b78c0d;
  /* color: #b78c0d; */
}
.online-survey .load-text {
  margin-left: 10px;
  font-size: 14px;
}
.online-survey .service {
  width: 309px;
  min-height: 920px;
  background: #ffffff;
  float: right;
  margin-top: 40px;
  padding: 0 30px;
  border-radius: 10px;
}
.online-survey .title {
  font-size: 30px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #222222;
  line-height: 25px;
  margin-top: 30px;
}
.online-survey .til {
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #222222;
  line-height: 56px;
}
/* .service ul {
  margin-bottom: 70px;
} */
.online-survey .service li {
  border-bottom: 1px solid #eeeeee;
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #999999;
  line-height: 56px;
  cursor: pointer;
}
.online-survey .el-submenu__title {
  border-bottom: none;
}
.online-survey .service .active {
  color: #b78c0d;
}
.online-survey .service hr {
  height: 1px;
  border: none;
  border-top: 1px solid #222222;
  margin-top: 30px;
}
.online-survey .tips {
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #999999;
  line-height: 26px;
}
.online-survey .order {
  width: 100%;
  height: 40px;
  border: 1px solid #b78c0d;
  border-radius: 4px 4px 4px 4px;
  background: #fff;
  color: #b78c0d;
  margin-top: 20px;
  margin-bottom: 52px;
  font-size: 18px;
  cursor: pointer;
}
</style>
